module.exports = __webpack_public_path__ + "img/icon_wechat_on.d73b4adf.png";